import keyMirror from 'keymirror';

import { DocumentChecklistItemState } from '../declarations';

export const DOCUMENT_CHECKLIST_ITEM_STATES: { [K in DocumentChecklistItemState]: K } = keyMirror({
  executed: true,
  initial: true,
  needs_external_signature: true,
  needs_od_signature: true,
  needs_review: true,
  received: true,
});

export const BRN_RELATED_DOCUMENT_TYPES = new Set([
  'brn_credit_addendum',
  'rs_brn_final',
  'rs_brn_initial',
  'rs_buyer_inspection_foundation',
  'rs_buyer_inspection_general',
  'rs_buyer_inspection_hvac',
  'rs_buyer_inspection_other',
  'rs_buyer_inspection_roof',
  'rs_buyer_inspection_termite',
]);

export const BINSR_FINAL_TYPE = 'rs_brn_final';
export const BRN_CREDIT_ADDENDUM_TYPE = 'brn_credit_addendum';
